const { TRUE } = require("sass");

class FeaturedCollectionPink extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const { showRecommendations, sectionId } = this.dataset;

    if (showRecommendations === 'true') {
      const { url } = this.dataset;

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
    
        fetch(url)
          .then(response => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('featured-collection-silverts');
    
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.initFeaturedCollectionSlider(this, sectionId);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };
  
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
    } else {
      this.initFeaturedCollectionSlider(this, sectionId);
    }
  }

  /**
   * The function `initFeaturedCollectionSlider` initializes a Swiper slider for a featured collection
   * with responsive breakpoints.
   * @param featuredCollectionPink - The `featuredCollectionPink` parameter is a reference to the DOM
   * element that represents the featured collection section in pink color on the webpage.
   * @param sectionId - The `sectionId` parameter is a unique identifier for the section where the
   * featured collection slider will be initialized. It is used to dynamically generate specific class
   * names for pagination and navigation elements within the slider based on the section it belongs to.
   * @returns If the `featuredCollectionPinkSlider` element is not found within the
   * `featuredCollectionPink` element, the function will return early and not initialize the Swiper
   * slider.
   */
  initFeaturedCollectionSlider (featuredCollectionPink, sectionId) {
    const featuredCollectionPinkSlider = featuredCollectionPink.querySelector('.featured-collection-silverts__slider');
  
    if (!featuredCollectionPinkSlider) return;
  
    const productsPerRowDesktop = parseInt(featuredCollectionPinkSlider.getAttribute('data-products-per-row-desktop'), 10) || 4;
    const productsPerRowTablet = parseInt(featuredCollectionPinkSlider.getAttribute('data-products-per-row-tablet'), 10) || 2;
    const productsPerRowMobile = parseInt(featuredCollectionPinkSlider.getAttribute('data-products-per-row-mobile'), 10) || 1;
    const columnSpacing = parseInt(featuredCollectionPinkSlider.getAttribute('data-column-spacing'), 10) || 10;

    const isLoopEnabled = window.innerWidth < 1024;

    new Swiper(featuredCollectionPinkSlider, {
      spaceBetween: columnSpacing,
      loop: true,
      loopAddBlankSlides: false,
      centeredSlides: false,
      pagination: {
        el: `.swiper-pagination--${sectionId}`,
        clickable: true
      },
      navigation: {
        nextEl: `.swiper-button-next--${sectionId}`,
        prevEl: `.swiper-button-prev--${sectionId}`
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          centeredSlides: true,
          spaceBetween: 10,
          loop: true
        },
        // when window width is >= 750px
        768: {
          slidesPerView: productsPerRowTablet,
          slidesPerGroup: productsPerRowTablet,
          centeredSlides: true,
          centerInsufficientSlides:true
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: productsPerRowDesktop,
          slidesPerGroup: productsPerRowDesktop,
          centeredSlides: false
        }
      }
    });
  }
}

customElements.define('featured-collection-silverts', FeaturedCollectionPink);
